// libs
import React, { memo } from 'react';

// styles
import { Container, DropDownButton, DropDownIcon } from './styles';

// defs
interface ICollapsibleExapnder {
  isExpanded: boolean;
}

function CollapsibleExpander({ isExpanded }: ICollapsibleExapnder) {
  return (
    <Container>
      <DropDownButton>
        <DropDownIcon showCollapsible={isExpanded} />
      </DropDownButton>
    </Container>
  );
}

export default memo(CollapsibleExpander);
